import { cn } from "@msuite/ui/utils";
import { memo } from "react";
import type { AbsencesCalendarCell } from "./use-absences-calendar";

/** Props Interface */
interface AbsencesCalendarHeaderWeekItemProps {
	cell: AbsencesCalendarCell;
}

function AbsencesCalendarHeaderWeekItemImpl({ cell }: AbsencesCalendarHeaderWeekItemProps) {
	const { cellMoment, isWeekend, isHoliday, isToday } = cell;

	/** Render */
	return (
		<div
			className={cn(
				"v-stack w-full h-full flex-center gap-0 items-center *:text-xs",
				isWeekend && "bg-gray-100 dark:bg-zinc-800",
				isHoliday && "stripes",
				isToday && "bg-primary-50 dark:bg-primary-950/50",
			)}
		>
			<p
				className={cn(
					isHoliday && "text-red-500!",
					isToday && "text-primary-600! dark:text-primary-400! font-semibold!",
				)}
			>
				{cellMoment.format("dd, DD.MM")}
			</p>
		</div>
	);
}

export const AbsencesCalendarHeaderWeekItem = memo(AbsencesCalendarHeaderWeekItemImpl);
